<template lang="html">
    <div class="">
        <div class="row d-none">
            <div class="col-sm-3 mb-2" v-if="!pricePerOrder">
                <label class="full">Custom Group</label>
                <input :disabled="disabled" class="w-100" type="text" style="width: 3rem;" v-model="currentGroupNameProp" placeholder="e.g: (> 2 years)">
            </div>
        </div>
        <div class="row" :class="{'min-height': pricePerPerson.genderPriceType === 2}">
            <div class="col-sm-3 pr-0" v-if="!isCustomGenderPrice(pricePerPerson)">
                <div class="d-flex w-100 justify-content-between">
                    <label class="full" v-if="!pricePerOrder">Price Category</label>
                </div>

                <v-select
                    v-if="audienceTypes && !isCustomGenderPrice(pricePerPerson)"
                    v-model="pricePerPerson.audienceTypeHelper"
                    :options="audienceTypes"
                    label="description"
                    placeholder="- Select type -"
                    :disabled="disabled"
                    @input="updateAudienceType(pricePerPerson, pricePerPerson.audienceTypeHelper)">
                </v-select>

                <input v-if="isCustomGenderPrice(pricePerPerson)" :disabled="disabled" :class="{'w-100': true, 'error-field': pricePerPerson.isRepeated}" type="text" style="width: 3rem;" v-model="pricePerPerson.audienceTypeDescription" @input="emitCustomUpdate()">
            </div>

            <div class="col-sm-3 pr-0" v-if="isCustomGenderPrice(pricePerPerson)">
                <div class="d-flex w-100 justify-content-between">
                    <label class="full" v-if="!pricePerOrder">Price Category</label>
                </div>
                <input v-if="isCustomGenderPrice(pricePerPerson)" :disabled="disabled" :class="{'w-100': true, 'error-field': pricePerPerson.isRepeated}" type="text" style="width: 3rem;" v-model="pricePerPerson.audienceTypeDescription" @input="emitCustomUpdate(pricePerPerson)">
            </div>

            <div class="col-sm-4 pr-0" v-if="isCustomGenderPrice(pricePerPerson)">
                <div class="d-flex w-100 justify-content-between">
                    <label class="full" v-if="!pricePerOrder">Category Association <span class="brand">*</span></label>
                </div>

                <v-select
                    v-if="isCustomGenderPrice(pricePerPerson)"
                    v-model="pricePerPerson.audienceTypeAssossiationHelper"
                    :options="audienceTypesNoCustom"
                    label="description"
                    placeholder="- Select association -"
                    :class="{'error-field': isCustomPriceValid(pricePerPerson)}"
                    :disabled="disabled"
                    :clearable="true"
                    @input="updateCustomAudienceType(pricePerPerson, pricePerPerson.audienceTypeAssossiationHelper)">
                </v-select>
            </div>

            <div v-if="showDelete && pricePerOrder" :class="{'d-flex justify-content-end align-items-center': true, 'col-sm-9': !isCustomGenderPrice(pricePerPerson), 'col-sm-5': isCustomGenderPrice(pricePerPerson)}">
                <i class="ico-delete fs-large medium" :class="{'pointer':!disabled, 'notAllowed':disabled}" v-tooltip="'Remove'" @click="removePrincingAgeRow(pricePerPerson)"></i>
            </div>

            <div class="col-sm-3 pr-0" v-if="!pricePerOrder">
                <div class="">
                    <label class="full">Label</label>
                    <input :disabled="disabled" class="w-100" type="text" style="width: 3rem;" v-model="pricePerPerson.audienceTypeLabel" placeholder="e.g: (> 2 years)">
                </div>
            </div>

            <div class="col-sm-2" v-if="!pricePerOrder && !isCustomGenderPrice(pricePerPerson)">
                <label class="full">Occupancy</label>
                <input :disabled="disabled || !isCustomGenderPrice(pricePerPerson)" class="text-center" type="number" style="width: 70px;" v-model="pricePerPerson.audienceTypeOccupancy" placeholder="1">
            </div>
            <div class="col-sm-2" v-if="!pricePerOrder && isCustomGenderPrice(pricePerPerson)">
                <label class="full">Occupancy</label>
                <input :disabled="disabled || !isCustomGenderPrice(pricePerPerson)" class="text-center" type="number" style="width: 100%;" v-model="pricePerPerson.audienceTypeOccupancy" placeholder="1">
            </div>

            <div class="d-flex flex-column ml-3">
                <div v-if="pricePerPerson.isRepeated" class="error">
                    <span>Custom name should be unique</span>
                </div>
    
                <div v-if="isCustomPriceValid(pricePerPerson)" class="error">
                    <span>A category association is required</span>
                </div>
            </div>
        </div>

        <div class="row align-items-center" v-if="!pricePerOrder">
            <div class="col-sm-3 pr-0">
                <label class="full">Tax</label>
                <input type="text" disabled="disabled" :value="customPerPersonTaxes(pricePerPerson.productGenderPriceComponents, pricePerPerson)" class="w-100" v-if="pricePerPerson.productGenderPriceComponents && pricePerPerson.productGenderPriceComponents.length > 0" />
                <v-select
                    v-if="taxes && pricePerPerson.productGenderPriceComponents && pricePerPerson.productGenderPriceComponents.length <= 0"
                    v-model="pricePerPerson.vatTypeHelper"
                    :options="taxes"
                    label="description"
                    placeholder="- Select tax -"
                    :disabled="disabled"
                    @input="updateTaxType(pricePerPerson, pricePerPerson.vatTypeHelper)">
                </v-select>
            </div>

            <div class="d-flex flex-column pl-3">
                <label class="full">Price</label>
                <div v-if="pricePerPerson.productGenderPriceComponents && pricePerPerson.productGenderPriceComponents.length > 0">
                    <div v-if="pricePerPerson.componentRuleType == 0" class="d-flex" >
                        <input type="text" :disabled="pricePerPerson.componentRuleType == 0 || disabled" :value="customPerPersonTotal(pricePerPerson)" style="width: 6rem;" class="glued-right" />
                        <div class="glued-left">€</div>
                    </div>
                    <div class="d-flex" v-else>
                        <input type="number" v-model="pricePerPerson.value" :disabled="disabled" style="width: 6rem;" class="glued-right" />
                        <div class="glued-left">€</div>
                    </div>
                </div>
                <div class="d-flex" v-else>
                    <input class="glued-right" type="number" style="width: 6rem;" :disabled="disabled" v-model="pricePerPerson.value">
                    <div class="glued-left">€</div>
                </div>
            </div>

            <div class="d-flex mr-3 flex-grow-1 flex-column">
                <label class="full">&nbsp;</label>
                <div class="d-flex mt-2 ml-2">
                    <div class="d-flex mr-2">
                        <i class="fas fa-calculator fs-large medium pointer" :class="{'dark': hasDecomposedPrices, 'notAllowed': disabled && !hasDecomposedPrices}" v-tooltip="'Edit'" @click="openEditPrice(pricePerPerson)"></i>
                    </div>
                    <div class="d-flex flex-grow-1">
                        <i class="fas fa-project-diagram fs-large medium pointer" :class="{'color-1': hasPriceDependencies, 'notAllowed': disabled && !hasPriceDependencies}" v-tooltip="'Dependencies'" v-if="prices.length > 1" @click="openGenderPriceDeps(pricePerPerson)"></i>
                    </div>
                    <div class="text-right">
                        <i class="ico-delete fs-large medium" :class="{'pointer':!disabled, 'notAllowed':disabled}" v-tooltip="'Remove'" v-if="showDelete" @click="removePrincingAgeRow(pricePerPerson)"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import extendedVSelect from '@/extends/vue-select'
import { priceManagerMixin } from '@/mixins/priceManager'

export default {
    mixins: [
        priceManagerMixin
    ],
    props: {
        priceGroup: {
            default: null
        },
        prices: {
            type: Array,
        },
        pricePerPerson: {
            required: true
        },
        showDelete: {
            type: Boolean,
            default: true,
        },
        disabled: {
            type: Boolean,
            default: false
        },
        pricePerOrder: {
            type: Boolean,
            default: false
        },
        audienceTypes: {
            type: Array,
        },
        editingEvent: {
            type: Boolean,
            default: false
        },
        currentGroupNameProp: null
    },
    data() {
      return {
        audienceTypesNoCustom: null,
        audienceTypeAssossiation: null,
        customCount: 0,
      }
    },
    watch: {
        // Listen for changes in props "audienceTypes" and perform actions
        audienceTypes: {
            deep: true,
            handler () {
                this.audienceTypesNoCustom = this.audienceTypes.filter(audienceType => audienceType.id < 500);
            }
        },
        // Check for changes in currentGroupNameProp and update it's new value to the pricePerPerson.audienceTypeGroup and priceGroup.groupName
        currentGroupNameProp: {
            deep: true,
            handler(val, oldVal) {
                this.priceGroup.groupPrices.map(pricePerPerson => pricePerPerson.audienceTypeGroup = val);
                this.priceGroup.groupName = val;
                this.$forceUpdate(); // This is important here, to force reactivity
            }
      }
    },
    created() {
        // Return all the audienceTypes without the custom audience types
        this.audienceTypesNoCustom = this.audienceTypes.filter(audienceType => audienceType.id < 500);
    },
    computed: {
        ...mapGetters([
            'getAudienceTypeList',
            'getVatTypes',
            'getModal',
            'getExtras'
        ]),
        taxes() {
            return this.getVatTypes;
        },
        hasPriceDependencies() {
            const priceDependencies = this.pricePerPerson.genderPriceDependencies;

            return priceDependencies.length > 0 && priceDependencies.some(dependency => dependency.isDeleted === false);
        },
        hasDecomposedPrices() {
            const decomposedPrices = this.pricePerPerson.productGenderPriceComponents;

            return decomposedPrices.length > 0;
        }
    },  
    methods:{
        ...mapActions([
            'openModal',
            'updateroductEditPriceData',
        ]),
        isCustomPriceValid(pricePerPerson) {
            return this.isCustomGenderPrice(pricePerPerson) && !pricePerPerson.audienceTypeAssossiationHelper;
        },
        emitCustomUpdate(pricePerPerson) {
            this.$emit('updatedCustomInput');
        },
        isCustomGenderPrice(pricePerPerson) {
            return pricePerPerson.audienceType >= 500;
        },
        updateAudienceType(row, selectedAudienceTypeHelper) {
            this.updateFlagsIfEventEdit();
            row.audienceType = selectedAudienceTypeHelper.id;
            row.audienceTypeDescription = `${selectedAudienceTypeHelper.description}`;

            this.emitCustomUpdate();
        },
        updateCustomAudienceType(row, selectedAudienceTypeAssossiationHelper) {
            this.updateFlagsIfEventEdit();
            const selected = selectedAudienceTypeAssossiationHelper || null;
            const associationId = selected && selected.id != null ? selected.id : null;

            this.$set(row, 'audienceTypeAssossiationHelper', selected);
            this.$set(row, 'audienceTypeAssossiation', associationId);

            this.emitCustomUpdate();
        },
        customPerPersonTaxes(row) {
            let taxes = [];

            for (let service of row) {
                if (!service || !service.component) continue;
                const vat = service.component.selectedPrice && service.component.selectedPrice.vatType != null
                    ? service.component.selectedPrice.vatType
                    : service.component.vatType;

                if (vat == null) continue;
                const vatPercentage = `${vat}%`;
                if (!taxes.includes(vatPercentage)) taxes.push(vatPercentage);
            }

            return taxes.join(', ');
        },
        updateTaxType(row, selectedVatType) {
            this.updateFlagsIfEventEdit();
            
            if (!selectedVatType) {
                selectedVatType = this.taxes[0];
            }

            row.vatType = selectedVatType.id;
        },
        updateValue(value) {
            return this.priceGroup.value = value;
        },
        customPerPersonTotal(pricePerPerson) { 
            let total = 0;

            if (pricePerPerson.componentRuleType == 0) {
                for (let service of pricePerPerson.productGenderPriceComponents) {
                    if (service.component.selectedPrice) {
                        total += service.component.selectedPrice.grossprice;
                    }
                }

                return (total).toFixed(2).replace(".", ",");
            }

            if (pricePerPerson.componentRuleType == 2) {
                for (let service of pricePerPerson.productGenderPriceComponents) {
                    if (service.component.selectedPrice && !service.isRemainingValue) {
                        total += service.component.selectedPrice.grossprice;
                    }
                }

                return (total).toFixed(2).replace(".", ",");
            }
        },
        openEditPrice(priceRow) {
            if (this.disabled && !this.hasDecomposedPrices) return;

            priceRow.isDisabled = this.disabled;

            if (this.getExtras.length === 0) {
                this.noServicesErrorMessage();
                
                return;
            }

            this.updateroductEditPriceData(priceRow);
            this.updateFlagsIfEventEdit();
            
            // If we open the "Edit Price" modal and we are already on a modal, then we need to seed a callback to re-open the previous modal
            if (this.getModal.show === false) {
                this.openModal('ProductEditPrice');
            } else {
                let currentModal = this.getModal.template;
                this.openModal({
                    name: 'ProductEditPrice',
                    callback: () => {
                        this.openModal(currentModal);
                    }
                });
            }
        },
        openGenderPriceDeps(priceRow) {
            if (this.disabled && !this.hasPriceDependencies) return;

            priceRow.isDisabled = this.disabled;

            this.updateroductEditPriceData(priceRow);
            this.updateFlagsIfEventEdit();
            
            // If we open the "Edit Price" modal and we are already on a modal, then we need to seed a callback to re-open the previous modal
            if (this.getModal.show === false) {
                this.openModal('GenderPricesDependencies');
            } else {
                let currentModal = this.getModal.template;
                this.openModal({
                    name: 'GenderPricesDependencies',
                    callback: () => {
                        this.openModal(currentModal);
                    }
                });
            }
        },
        removePrincingAgeRow(index) {
            if (this.disabled) return false;
            
            this.$emit('delete', index);
        },
        updateFlagsIfEventEdit() {
            // Adding a updateflag to Prices on editEvent | mixin.js
            if (this.editingEvent) this.eventActivateUpdateFlag('Prices');
        }
    },
    components: {
        vSelect: extendedVSelect,
    }
}
</script>

<style lang="scss" scoped>
    .min-height {
        min-height: 84px;
    }
</style>

<style lang="scss">
    .dropdown.v-select.error-field {
        .dropdown-toggle {
            border: 1px solid #e73f47;
            overflow: hidden;
        }
    }
</style>



// WEBPACK FOOTER //
// priceRow.vue?84686bbc